import { z } from "zod";

export const GoogleLoginResponseSchema = z.object({
  redirect: z.string(),
});

export type GoogleLoginResponseType = z.infer<typeof GoogleLoginResponseSchema>;
